"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uuid = require("uuid");
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _styledComponents = require("styled-components");
var _styled = require("../styled");
var _SwitchBaseInput = _interopRequireDefault(require("./SwitchBaseInput"));
var _excluded = ["theme", "testId", "id", "htmlFor", "icon", "label", "value", "name", "infoBoxText", "isChecked", "isDisabled", "showLabelTooltipOnOverflow", "onBlur", "onChange", "onFocus", "onMouseEnter", "onMouseLeave", "inputProps", "labelProps", "role"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SwitchBase = /*#__PURE__*/function (_Component) {
  _inherits(SwitchBase, _Component);
  var _super = _createSuper(SwitchBase);
  function SwitchBase() {
    var _this;
    _classCallCheck(this, SwitchBase);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      id: (0, _uuid.v4)()
    });
    /**
     * On change handler
     * @param {Event} event - React SyntheticEvent
     */
    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (event) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        value = _this$props.value,
        isDisabled = _this$props.isDisabled;

      // stop propagation, as we want to send only a change with value
      event.stopPropagation();
      if (isDisabled) return;
      onChange(value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleOnKeyPress", function (event) {
      var isDisabled = _this.props.isDisabled;
      if (isDisabled) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
    return _this;
  }
  _createClass(SwitchBase, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        theme = _this$props2.theme,
        testId = _this$props2.testId,
        id = _this$props2.id,
        htmlFor = _this$props2.htmlFor,
        icon = _this$props2.icon,
        label = _this$props2.label,
        value = _this$props2.value,
        name = _this$props2.name,
        infoBoxText = _this$props2.infoBoxText,
        isChecked = _this$props2.isChecked,
        isDisabled = _this$props2.isDisabled,
        showLabelTooltipOnOverflow = _this$props2.showLabelTooltipOnOverflow,
        onBlur = _this$props2.onBlur,
        onChange = _this$props2.onChange,
        onFocus = _this$props2.onFocus,
        onMouseEnter = _this$props2.onMouseEnter,
        onMouseLeave = _this$props2.onMouseLeave,
        inputProps = _this$props2.inputProps,
        labelProps = _this$props2.labelProps,
        role = _this$props2.role,
        rest = _objectWithoutProperties(_this$props2, _excluded);
      var uid = id || htmlFor || this.state.id;
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement(_styled.SwitchBaseWrapper, _extends({
        theme: theme,
        isDisabled: isDisabled
      }, rest), /*#__PURE__*/_react["default"].createElement(_styled.SwitchBaseLabel, _extends({
        isDisabled: isDisabled,
        htmlFor: uid,
        infoBoxText: infoBoxText,
        theme: theme.label,
        showTooltipOnOverflow: showLabelTooltipOnOverflow
      }, labelProps, {
        value: /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
          theme: theme
        }, /*#__PURE__*/_react["default"].createElement(_SwitchBaseInput["default"], _extends({
          testId: testId,
          id: uid,
          value: value,
          type: "checkbox",
          name: name,
          role: role,
          isChecked: isChecked,
          isDisabled: isDisabled,
          onChange: this.handleOnChange,
          onBlur: onBlur,
          onFocus: onFocus,
          onKeyPress: this.handleOnKeyPress,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          icon: icon
        }, inputProps)), !!label && /*#__PURE__*/_react["default"].createElement(_styled.LabelTextWrapper, {
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave
        }, label))
      }))));
    }
  }]);
  return SwitchBase;
}(_react.Component);
SwitchBase.propTypes = {
  /**
   * Switch base theme
   */
  theme: _propTypes["default"].object,
  /**
   * Switch test id
   */
  testId: _propTypes["default"].string,
  /**
   * Value for `id` input attribute and `htmlFor` label attribute
   */
  id: _propTypes["default"].string,
  /**
   * Specifies which element the label is bound to
   * @deprecated
   */
  htmlFor: _propTypes["default"].string,
  /**
   * Icon component for the switch base
   */
  icon: _propTypes["default"].node,
  /**
   * Specifies the label content for the switch (text or custom component)
   */
  label: _propTypes["default"].node,
  /**
   * Input value
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired
  })]),
  /**
   * Input name
   */
  name: _propTypes["default"].string,
  /**
   * Shows info icon and renders text inside Tooltip
   */
  infoBoxText: _propTypes["default"].node,
  /**
   * Specifies if the switch is checked
   */
  isChecked: _propTypes["default"].bool,
  /**
   * Specifies if the switch is disabled
   */
  isDisabled: _propTypes["default"].bool,
  /**
   * Whether to show tooltip when the Label content overflows label.
   * Note: The Label content is the input, icon and the text
   */
  showLabelTooltipOnOverflow: _propTypes["default"].bool,
  /**
   * Synthetic event
   */
  onBlur: _propTypes["default"].func,
  /**
   * Callback for the switch input
   */
  onChange: _propTypes["default"].func,
  /**
   * Synthetic event
   */
  onMouseEnter: _propTypes["default"].func,
  /**
   * Synthetic event
   */
  onMouseLeave: _propTypes["default"].func,
  /**
   * Synthetic event
   */
  onFocus: _propTypes["default"].func,
  /**
   * Switch label props
   */
  labelProps: _propTypes["default"].object,
  /**
   * Switch input props
   */
  inputProps: _propTypes["default"].object,
  /**
   * Role value
   */
  role: _propTypes["default"].string
};
SwitchBase.defaultProps = {
  theme: {},
  testId: 'SWITCH',
  id: undefined,
  htmlFor: undefined,
  icon: null,
  label: null,
  value: '',
  name: undefined,
  infoBoxText: undefined,
  isChecked: false,
  isDisabled: false,
  showLabelTooltipOnOverflow: true,
  onBlur: _lodash["default"],
  onChange: _lodash["default"],
  onFocus: _lodash["default"],
  onMouseEnter: _lodash["default"],
  onMouseLeave: _lodash["default"],
  labelProps: {},
  inputProps: {},
  role: undefined
};
var _default = SwitchBase;
exports["default"] = _default;